import React, { useEffect, useState } from "react";
import "./Developer.css";
import baseURL from "../url";

export default function Developer() {
  const [dev, setDev] = useState(null);

  useEffect(() => {
    fetch(`${baseURL}/developerGet.php`)
      .then((r) => r.json())
      .then((data) => {
        const obj = Array.isArray(data) ? data[0] : data;
        setDev(obj && Object.keys(obj).length ? obj : null);
      })
      .catch((err) => {
        console.error(err);
        setDev(null);
      });
  }, []);

  if (!dev) return null;

  return (
    <div className="Developer">
      <a
        href={dev.url}
        target="_blank"
        rel="noopener noreferrer"
        className="developer-link"
      >
        {dev.nombre}
      </a>
      <span className="developer-text">{dev.copyright}</span>
    </div>
  );
}
